/**
 * Sitewide: force every link that points off cowtownstitch.com (Instagram,
 * TikTok, or any other external domain typed into a rich-text field, a
 * generic "link" setting, etc.) to open in a new tab. Shopify's rich text
 * editor doesn't offer an "open in new tab" toggle for inline links, so this
 * catches those in addition to theme-setting-driven links that were left on
 * their default (same-tab) behavior.
 *
 * A MutationObserver keeps this working for content that renders after the
 * initial page load (quick add, cart drawer, section re-renders, etc).
 */
(function () {
  function markExternalLink(link) {
    if (!link || link.dataset.externalLinkChecked) return;
    link.dataset.externalLinkChecked = 'true';

    const href = link.getAttribute('href');
    if (!href) return;
    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('sms:') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    if (url.hostname && url.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      const relParts = (link.getAttribute('rel') || '').split(' ').filter(Boolean);
      if (!relParts.includes('noopener')) relParts.push('noopener');
      if (!relParts.includes('noreferrer')) relParts.push('noreferrer');
      link.setAttribute('rel', relParts.join(' '));
    }
  }

  function scan(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('a[href]').forEach(markExternalLink);
  }

  scan(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('a[href]')) markExternalLink(node);
        scan(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
